type RetrieveTaskError = {
  notFound: boolean;
};

const retrieveTaskError: RetrieveTaskError = {
  notFound: false,
};

export type { RetrieveTaskError };

export { retrieveTaskError };
